<template>
    <div class="all-height" style="width: 100%;position: relative">
        <el-main class="full-screen">
            <div class="operation-bar">
                <h1>用户管理</h1>
                <div class="operation-bar-right">
                    <el-select v-if="isAdmin" style="margin-left: 20px" v-model="queryData.role" size="mini" placeholder="账号类型">
                        <el-option label="全部账号类型" value=""></el-option>
                        <el-option label="管理员" value="0"></el-option>
                        <el-option label="主账号" value="1"></el-option>
                        <el-option label="子账号" value="2"></el-option>
                        <el-option label="采购员" value="3"></el-option>
                    </el-select>
                    <div class="input-box" v-if="isAdmin">
                        <i></i>
                        <input type="text" v-model="searchVendorName" placeholder="请选择供应商" readonly @focus="clickSearchVendor"/>
                    </div>
                    <div class="input-box">
                        <i class="el-icon-search" @click="loadDataList(1)"></i>
                        <input type="text" v-model="queryData.username" placeholder="请输入用户名"/>
                    </div>
                    <a href="javascript:void(0)" @click="loadDataList(1)">查询</a>
                    <a href="javascript:void(0)" @click="addUser">添加</a>
                </div>
            </div>

            <div class="table-box">
                <el-table ref="table" :data="userList" height="calc(100% - 55px)" v-loading="listLoading"
                          @selection-change="selsChange"
                          :header-cell-style="{background:'#4885CA',color: 'white'}"
                >
                    <el-table-column  type="index" label="序号" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="username" width="250" label="账号" header-align="center" align="center" :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column prop="manname" width="250" label="姓名" header-align="center" align="center" :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column  label="状态" width="80" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-tag effect="light" type="success" v-if="scope.row.isFreeze === 0">启用</el-tag>
                            <el-tag effect="light" type="info" v-if="scope.row.isFreeze === 1">冻结</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column  width="250" prop="vendorName" label="所属供应商" header-align="center" align="center" :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column  width="120" prop="type" label="账号类型" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-tag effect="light" type="danger" v-if="scope.row.role === 0">管理员</el-tag>
                            <el-tag effect="light" v-if="scope.row.role === 1">主账号</el-tag>
                            <el-tag effect="light" type="success" v-if="scope.row.role === 2">子账号</el-tag>
                            <el-tag effect="light" type="warning" v-if="scope.row.role === 3">采购员</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column  width="120" prop="mobile" label="联系方式" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="createUser" label="创建人" header-align="center" align="center" :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" header-align="center" align="center">
                        <template slot-scope="scope">
                            {{dateFormat(scope.row.createTime)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button @click="resetUser(scope.row)" type="text" size="small">重置</el-button>
                            <el-button @click="editUser(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button @click="delUser(scope.row)" type="text" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="table-page">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="page.current"
                            :page-sizes="page.pageSizes"
                            :page-size="page.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="page.total">
                    </el-pagination>
                </div>
            </div>
        </el-main>
        <select-vendor-dialog :show-flag="showFlag" ref="selectVendor" @selectVendor="selectVendor" @closeDialog="closeSearchVendor" @clearSearchVendor="clearSearchVendor"></select-vendor-dialog>
        <user-dialog ref="userDialog" :title="userDialogTitle" @closeHandler="refreshTable"></user-dialog>
    </div>
</template>
<script>
    import selectVendorDialog from './select-vendor-dialog'
    import userDialog from './user-dialog'
    import {mapState} from 'vuex';
    import dayjs from 'dayjs';
    export default {
        name: 'userOperation',
        components: {userDialog, selectVendorDialog},
        computed: {
            ...mapState('login', ['currentUser', 'isAdmin', 'isMain']),
            ...mapState('system/user', ['userList', 'page'])
        },
        data() {
            return {
                showFlag: false,
                editBtnDisable: true,
                delBtnDisable: true,
                listLoading: false,
                current: 1,
                userDialogTitle: '',
                queryData: {
                    role: '',
                    vendorNo: '',
                    username: ''
                },
                searchVendorName: '',
                searchSupplier: {
                    pkSupplier: '',
                    vendorName: '',
                    role: ''
                }
            }
        },
        methods: {
            clickSearchVendor() {
                this.showFlag = true;
            },
            closeSearchVendor() {
                this.showFlag = false;
            },
            selectVendor(item) {
                this.searchVendorName = item.vendorName;
                this.queryData.vendorNo = item.vendorNo;
            },
            addUser() {
                this.userDialogTitle = '添加用户';
                this.$refs.userDialog.show();
            },
            editUser(row) {
                this.userDialogTitle = '编辑用户';
                this.$refs.userDialog.show(JSON.parse(JSON.stringify(row)));
            },
            delUser(item) {
                this.$confirm('删除用户 '+ item.username +', 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'info'
                }).then(() => {
                    this.$store.dispatch('system/user/delete',{id: item.id}).then((res) => {
                        if(res.code === '200') {
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            });
                            this.refreshTable();
                        } else{
                            this.$message.error(res.data?res.data : res.message);
                        }
                    });
                });
            },
            resetUser(item) {
                this.$confirm('重置该用户密码, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'info'
                }).then(() => {
                    this.$store.dispatch('system/user/resetPwd',{id: item.id}).then((res) => {
                        if(res.code === '200') {
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            });
                        } else {
                            this.$message.error('重置失败！');
                        }
                    });
                });
            },
            refreshTable() {
                this.loadDataList();
            },
            clearSearchVendor() {
                this.searchVendorName = '';
                this.queryData.vendorNo = '';
            },
            handleSizeChange(val) {
                this.$store.dispatch('system/user/setPageSize', val);
                this.loadDataList();
            },
            handleCurrentChange(val) {
                this.$store.dispatch('system/user/setPageCurrent', val);
                this.loadDataList();
            },
            loadDataList(currentPage) {
                if(currentPage){
                    this.$store.dispatch('system/user/setPageCurrent', currentPage);
                }
                this.listLoading = true;
                this.$store.dispatch("system/user/listPage", this.queryData);
                this.listLoading = false;
            },
            dateFormat(val) {
                if (val) {
                    return dayjs(val).format('YYYY-MM-DD hh:mm:ss');
                } else {
                    return '';
                }
            },
            selsChange(sels) {
                if(sels.length === 1) {
                    this.editBtnDisable = false;
                    this.delBtnDisable = false;
                } else {
                    this.editBtnDisable = true;
                    if(sels.length === 0) {
                        this.delBtnDisable = true;
                    } else {
                        this.delBtnDisable = false;
                    }
                }
            }
        },
        created() {
            this.loadDataList();
        }
    };
</script>
<style scoped>
    .table-box {
        position: relative;
        background-color: white;
        height: calc(100% - 35px);
        width: 100%;
    }
    .table-page {
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: 10px;
    }
    .el-scrollbar li {
        float: none;
    }
</style>
